import dayjs from 'dayjs';
import { TableColumn } from 'layout/TableLayout/types';
import { BugReportListData } from '../types';

const BUG_REPORT_LIST_COLUMNS: TableColumn<BugReportListData>[] = [
  {
    title: 'Дата создания',
    name: 'createdAt',
    render: ({ createdAt }) => dayjs(createdAt).format('DD.MM.YYYY'),
  },
  {
    title: 'Тема',
    name: 'topic',
    render: ({ topic }) => topic,
  },
  {
    title: 'Описание',
    name: 'description',
    render: ({ description }) => description,
  },
  {
    title: 'ID кандидата',
    name: 'candidateId',
    render: ({ candidate }) => candidate.id,
  },
  {
    title: 'Кандидат',
    name: 'candidate',
    render: ({ candidate }) =>
      candidate.fullName ||
      candidate.candidateUsername.telegramUsername ||
      candidate.candidateUsername.email ||
      candidate.candidateUsername.login ||
      '-',
  },
  {
    title: 'Телефон',
    name: 'phoneNumber',
    render: ({ candidate }) => candidate.phoneNumber || '-',
  },
];

export default BUG_REPORT_LIST_COLUMNS;
